import type { ReactNode } from "react";
import { Spinner, Alert, Button } from "@vlab-corporation/design-system";

interface QueryStateHandlerProps {
  isLoading: boolean;
  error: Error | null;
  errorMessage?: string;
  onRetry?: () => void;
  isEmpty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

export function QueryStateHandler({
  isLoading,
  error,
  errorMessage,
  onRetry,
  isEmpty,
  emptyMessage,
  children,
}: QueryStateHandlerProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <Spinner size="md" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="error">
        {errorMessage ?? "데이터를 불러오지 못했습니다."}
        {onRetry && (
          <Button variant="outline" onClick={onRetry} className="ml-2">
            재시도
          </Button>
        )}
      </Alert>
    );
  }

  if (isEmpty) {
    return (
      <div className="text-center py-8 text-gray-400">{emptyMessage ?? "데이터가 없습니다."}</div>
    );
  }

  return <>{children}</>;
}
